
import {RoadmapItem} from "@/models/roadmap-item";
import {RoadmapService} from "@/services/roadmap-service";
import Vue from "vue";
import AppSelectApp from "@/components/SelectApp.vue";
import AppSelectRoadmapStatus from "@/components/SelectRoadmapStatus.vue";
import {ISelectItem} from "winfakt-vue-components";
import {App, getAppSelectItems} from "@/utils/apps";
import {VueEditor} from "vue2-editor";
import {Quill} from "quill";

export default Vue.extend({
	data() {
		return {
			item: new RoadmapItem()
		};
	},
	computed: {
		title(): string {
			if (this.item.id == 0) {
				return "New roadmap item";
			}
			return "Edit roadmap item";
		},
		appItems(): ISelectItem<App>[] {
			return getAppSelectItems().filter(a => a.value != App.WINFAKT_ONLINE_AUTH);
		},
		hasDate(): boolean {
			return this.item.date != null;
		}
	},
	methods: {
		async save() {
			if (this.item.id == 0) {
				let items = await RoadmapService.getItemsByAppName(this.item.appName);
				this.item.priority = 1;
				if (items.length > 0) {
					this.item.priority = items[items.length - 1].priority + 1;
				}
				this.item = await RoadmapService.postItem(this.item);
			} else {
				this.item = await RoadmapService.putItem(this.item);
			}
			this.$router.push("/roadmap");
		},
		setHasDate(value: boolean) {
			if (value) {
				this.item.date = new Date();
			} else {
				this.item.date = null;
			}
		},
		async onImageAdded(file: File, editor: Quill, cursorLocation: number, resetUploader: Function) {
			console.log("On image added");
			let url = await RoadmapService.uploadImage(file);
			editor.insertEmbed(cursorLocation, "image", url);
			resetUploader();
		}
	},
	async mounted() {
		let idStr = this.$route.params["id"];
		if (!idStr) return;
		let id = parseInt(idStr) || 0;
		if (id == 0) return;
		this.item = await RoadmapService.getItem(id);
		if (this.item.date) {
			this.item.date = new Date(this.item.date);
		}
	},
	components: {
		AppSelectApp,
		AppSelectRoadmapStatus,
		VueEditor
	}
});
